import React, { useCallback, useEffect, useRef, useState } from "react";
import dayjs from "dayjs";
import "../../../App.css";
import { FaStop } from "react-icons/fa6";
import { IoIosCheckmark } from "react-icons/io";
import { useNavigate, useSearchParams } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import Select from "react-select";
import noDataFound from "../../../components/assets/No data-rafiki 1.svg";
import clock_inActive from "../../../components/assets/clock_inActive.svg";
import high from "../../../components/assets/high_priority.svg";
import low from "../../../components/assets/low_priority.svg";
import normal from "../../../components/assets/normal_priority.svg";
import RequestIconActive from "../../../components/assets/request_icon_active.svg";
import start_button from "../../../components/assets/start-icon.svg";
import { getRequest } from "../../../components/axiosClient";
import LoadingSpinner from "../../../components/loader/LoadingSpinner";
import { errorNotification } from "../../../components/toast-notification/common-toast";
import { GET_USER_TASKS } from "../../../components/utils";
import html2canvas from "html2canvas";
import { toBlob } from "html-to-image";
import CameraAltIcon from "@mui/icons-material/CameraAlt";

import {
  Box,
  ClickAwayListener,
  Drawer,
  TextField,
  Tooltip,
  Button,
} from "@mui/material";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import {
  pageLimit,
  priorityOptionsAll,
} from "../../../components/common/const";
import CustomTable from "../../../components/common/DataGridTable";
import CustomDataGridTable from "../../../components/common/DataGridTable";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { render } from "@testing-library/react";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import DrawerTaskDetail from "../../../components/Drawer/DrawerTaskDetail";

const drawerWidth = "70%";
const AllTaskList = React.memo(
  ({
    onStart,
    handlePause,
    runningTask,
    handleRequestModal,
    projectList,
    handleTaskComplete,
  }) => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [firstLoading, setFirstLoading] = useState(false);
    const [pageInformation, setPageInformation] = useState({});
    const [open, setOpen] = useState(false);
    const [selectedTaskId, setSelectedTaskId] = useState(null);
    // const [dueDate, setDueDate] = useState([]);
    // const pageSize = 30;
    const [page, setPage] = useState(1);
    const [taskList, setTaskList] = useState([]);
    const [hasMoreData, setHasMoreData] = useState(true);
    const isMounted = useRef(false);
    const taskListRef = useRef();
    const tableRef = useRef(null);
    const [searchParams, setSearchParams] = useSearchParams();

    const projectParams = searchParams.get("project");
    const [projectFilter, setProjectFilter] = useState(
      projectParams ? parseInt(projectParams) : null
    );

    const statusParams = searchParams.get("status");
    const [statusFilter, setStatusFilter] = useState(
      statusParams ? statusParams : null
    );

    const priorityParams = searchParams.get("priority");
    const [priorityFilter, setPriorityFilter] = useState(
      priorityParams ? priorityParams : null
    );

    const dateParams =
      searchParams.get("due_date") || dayjs().format("YYYY-MM-DD");
    const [dateFilter, setDateFilter] = useState(
      dateParams ? dateParams : dayjs().format("YYYY-MM-DD")
    );

    const handleTaskView = (id) => {
      setOpen(true);
      setSelectedTaskId(id);
      // navigate(`/task-details/${id}`);
    };
    const handleDrawerClose = () => {
      if (open) {
        setOpen(false);
        setSelectedTaskId(null);
        getTaskList();
      }
    };

    useEffect(() => {
      if (!isMounted.current) {
        getTaskList();
        isMounted.current = true;
      }
    }, [projectFilter, statusFilter, priorityFilter, dateFilter]);

    const getTaskList = async () => {
      try {
        let apiUrl = `${GET_USER_TASKS}?page=${1}&limit=${pageLimit}`;
        if (projectFilter && projectFilter !== "All") {
          apiUrl += `&project_id=${projectFilter}`;
        }
        if (statusFilter && statusFilter !== "All") {
          apiUrl += `&status=${statusFilter}`;
        }
        if (priorityFilter && priorityFilter !== "All") {
          apiUrl += `&priority=${priorityFilter}`;
        }
        if (dateFilter && dateFilter !== null) {
          apiUrl += `&due_date=${dateFilter}`;
        }
        const res = await getRequest(apiUrl, null, navigate);
        if (
          res.data &&
          res.data.data &&
          Array.isArray(res.data.data.page_data)
        ) {
          setTaskList(res.data.data.page_data);
          // console.log(res.data.data.page_data);
          setPageInformation(res.data.data.page_information);
          setPage(2);
          // const dates = [
          //   ...new Set(res.data.data.page_data.map((item) => item.due_date)),
          // ];
          // setDueDate(dates);
        } else {
          setHasMoreData(false);
          errorNotification(res.errormessage);
          setTaskList([]);
        }
        setFirstLoading(false);
      } catch (error) {
        errorNotification(error);
        setFirstLoading(false);
      }
    };

    const handleCheckmarkClick = async (e) => {
      await handleTaskComplete(e.id, e.row.is_completed);
      await getTaskList();
    };

    const rows =
      taskList?.map((user, index) => ({
        id: user?.id,
        no: index + 1,
        project_id: user?.project?.id,
        title: user?.title,
        project: user?.project?.name,
        created_by:
          (user?.assignor?.first_name || "") +
          " " +
          (user?.assignor?.last_name || ""),
        assignee:
          (user?.assignee?.first_name || "") +
          " " +
          (user?.assignee?.last_name || ""),
        due_date: user?.due_date,
        task_status: user?.task_status?.title,
        priority: user?.priority,
        is_completed: user?.is_completed,
      })) || [];

    const columns = [
      {
        field: "checkmark",
        headerName: "",
        width: 50,
        cellClassName: "checkMark-tasklist",
        renderCell: (e) => (
          <Box
            onClick={(event) => {
              event.stopPropagation();
              handleCheckmarkClick(e);
            }}
            className={`rounded-full border flex items-center${
              !e?.row?.is_completed
                ? "bg-white text-black"
                : "bg-green-600 text-white"
            } cursor-pointer`}
          >
            <IoIosCheckmark />
          </Box>
        ),
      },
      {
        field: "no",
        headerName: "No",
        width: 80,
        renderCell: (params) => params.value || "--",
      },
      {
        field: "title",
        headerName: "Name",
        width: 600,
        // flex: 1,
        renderCell: (params) => params.value || "--",
      },
      {
        field: "project",
        headerName: "Project",
        width: 300,
        // flex: 1,
        renderCell: (params) => params.value || "--",
      },
      {
        field: "created_by",
        headerName: "Created By",
        width: 140,
        renderCell: (params) => (params.value?.trim() ? params.value : "--"),
      },
      {
        field: "assignee",
        headerName: "Assignee",
        width: 140,
        renderCell: (params) => (params.value?.trim() ? params.value : "--"),
      },
      {
        field: "due_date",
        headerName: "Due Date",
        width: 140,
        renderCell: (params) => params.value || "--",
      },
      {
        field: "task_status",
        headerName: "Status",
        width: 150,
        renderCell: (params) => {
          const statusdata = params.value || "--";
          let className = "";
          switch (statusdata) {
            case "In Progress":
              className = "text-[#db763b] bg-[#eeb08c3d] rounded-xl";
              break;
            case "Completed":
              className = "text-[#83BF6E] bg-[#83bf6e24] rounded-xl";
              break;
            case "To be verified":
              className = "text-[#8E59FF] bg-[#8e59ff1a] rounded-xl";
              break;
            case "To do":
              className = "text-[#6F767E] bg-[#6f767e2b] rounded-xl";
              break;
            case "Confirm-Sale":
              className = "text-[#6F767E] bg-[#6F767E24] rounded-xl";
              break;
            case "Open":
              className = "text-[#83BF6E] bg-[#83bf6e24] rounded-xl";
              break;
            case "Closed":
              className = "text-[#EE404C] bg-[#ff00001a] rounded-xl";
              break;
            case "In Meeting":
              className = "text-[#8E59FF] bg-[#8e59ff1a] rounded-xl";
              break;
            default:
              className = "text-[#6F767E] bg-[#6f767e2b] rounded-xl";
          }
          return (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                height: "100%",
                width: "100%",
              }}
            >
              <Box
                className={className}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "80%",
                  width: "80%",
                }}
              >
                {statusdata}
              </Box>
            </Box>
          );
        },
      },
      {
        field: "priority",
        headerName: "Priority",
        width: 150,
        renderCell: (params) => params.value || "--",
      },
    ];

    // const fetchData = useCallback(async () => {
    //   if (
    //     loading ||
    //     pageInformation?.current_page >= pageInformation?.last_page
    //   )
    //     return;

    //   setLoading(true);
    //   try {
    //     let apiUrl = `${GET_USER_TASKS}?page=${page}&limit=${pageLimit}`;
    //     if (projectFilter && projectFilter !== "All") {
    //       apiUrl += `&project_id=${projectFilter}`;
    //     }
    //     if (statusFilter && statusFilter !== "All") {
    //       apiUrl += `&status=${statusFilter}`;
    //     }
    //     if (priorityFilter && priorityFilter !== "All") {
    //       apiUrl += `&priority=${priorityFilter}`;
    //     }
    //     const res = await getRequest(apiUrl, null, navigate);
    //     if (
    //       res.data &&
    //       res.data.data &&
    //       Array.isArray(res.data.data.page_data)
    //     ) {
    //       const newPageData = res.data.data.page_data;
    //       setTaskList((preData) => [...preData, ...newPageData]);
    //       setPageInformation(res.data.data.page_information);
    //       setPage((prevPage) => prevPage + 1);
    //     }
    //     if (
    //       res.data.data.page_information.current_page >=
    //       res.data.data.page_information.last_page
    //     ) {
    //       setHasMoreData(false);
    //     }
    //   } catch (error) {
    //     errorNotification(error);
    //   } finally {
    //     setLoading(false);
    //   }
    // }, [page, loading, hasMoreData]);

    // const handleScroll = () => {
    //   if (taskListRef.current) {
    //     const { scrollTop, clientHeight, scrollHeight } = taskListRef.current;

    //     if (scrollTop + clientHeight >= scrollHeight - 200) {
    //       if (!loading) {
    //         fetchData();
    //       }
    //     }
    //   }
    // };

    // useEffect(() => {
    //   const divElement = taskListRef.current;
    //   let debounceTimeout;

    //   const handleDebouncedScroll = () => {
    //     clearTimeout(debounceTimeout);
    //     debounceTimeout = setTimeout(handleScroll, 200);
    //   };

    //   if (divElement) {
    //     divElement.addEventListener("scroll", handleDebouncedScroll);
    //   }

    //   return () => {
    //     if (divElement) {
    //       divElement.removeEventListener("scroll", handleDebouncedScroll);
    //     }
    //     clearTimeout(debounceTimeout);
    //   };
    // }, [fetchData, loading]);

    const customIcons = {
      High: (
        <img src={high} alt="High" style={{ width: "14px", height: "14px" }} />
      ),
      Medium: (
        <img
          src={normal}
          alt="Medium"
          style={{ width: "14px", height: "14px" }}
        />
      ),
      Low: (
        <img src={low} alt="Low" style={{ width: "14px", height: "14px" }} />
      ),
    };

    const projectFilterOptions = [
      { label: "All", value: "All" },
      ...projectList,
    ];

    const statusFilterOptionList = [
      "All",
      "To do",
      "In progress",
      "To be verified",
      "Completed",
    ];
    const role_accesses =
      JSON.parse(secureLocalStorage.getItem("role_accesses")).find(
        (access) => access.module.name === "Project Lead"
      )?.access_type !== "None";

    if (role_accesses) {
      statusFilterOptionList.push(
        "Open",
        "In Meeting",
        "Confirm-Sale",
        "Closed"
      );
    }
    const statusFilterOption = statusFilterOptionList.map((props) => ({
      label: props,
      value: props,
    }));

    // const priorityOptionsList = ["All", "Low", "Medium", "High"];
    const priorityFilterOption = priorityOptionsAll.map((props) => ({
      label: props,
      value: props,
    }));

    // const handleSnapshotCopy = async () => {
    //   if (!tableRef.current) return;

    //   const canvas = await html2canvas(tableRef.current, {
    //     scale: 2,
    //     useCORS: true,
    //   });

    //   canvas.toBlob(async (blob) => {
    //     if (!blob) return;

    //     try {
    //       await navigator.clipboard.write([
    //         new ClipboardItem({ "image/png": blob }),
    //       ]);
    //       alert("Snapshot copied to clipboard!");
    //     } catch (err) {
    //       console.error("Copy failed", err);
    //       alert("Your browser does not support image clipboard copy.");
    //     }
    //   });
    // };

    // const filterDate = dueDate.map((props) => ({
    //   label: props,
    //   value: props,
    // }));

    // const dueDateFilterOption = [{ label: "All", value: "All" }, ...filterDate];
    // console.log(dueDateFilterOption);





    // const handleSnapshotCopy = async () => {
    //   if (!tableRef.current) return;

    //   // Backup old styles
    //   const originalOverflow = document.body.style.overflow;
    //   const originalScrollTop = window.scrollY;

    //   // Expand and adjust for full capture
    //   document.body.style.overflow = "visible";
    //   window.scrollTo(0, 0); // Scroll to top to avoid clipping

    //   const tableNode = tableRef.current;
    //   tableNode.classList.add("disable-sticky-header");

    //   try {
    //     const canvas = await html2canvas(tableNode, {
    //       // scale: 1,
    //       useCORS: true,
    //       scrollY: -window.scrollY, // key to avoid clipping top
    //       backgroundColor: "#fff",
    //     });

    //     canvas.toBlob(async (blob) => {
    //       if (!blob) return;

    //       try {
    //         await navigator.clipboard.write([
    //           new ClipboardItem({ "image/png": blob }),
    //         ]);
    //         alert("Snapshot copied to clipboard!");
    //       } catch (err) {
    //         console.error("Clipboard error", err);
    //         alert("Your browser doesn't support clipboard image copy.");
    //       }
    //     });
    //   } finally {
    //     // Restore styles
    //     tableNode.classList.remove("disable-sticky-header");
    //     document.body.style.overflow = originalOverflow;
    //     window.scrollTo(0, originalScrollTop);
    //   }
    // };


const handleSnapshotCopy = async () => {
  if (!tableRef.current) return;

  await document.fonts.ready;

  // Save current styles
  const originalWidth = tableRef.current.style.width;
  const scrollContainer = tableRef.current.querySelector('.MuiDataGrid-virtualScroller');

  // Force full width
  const fullWidth = scrollContainer.scrollWidth;
  tableRef.current.style.width = `${fullWidth}px`;
  await new Promise((res) => setTimeout(res, 100));
  try {
    const blob = await toBlob(tableRef.current, {
      pixelRatio: 2,
      backgroundColor: "#ffffff",
      style: {
        margin: "0",
        padding: "0",
      },
      cacheBust: true,
    });

    if (!blob) throw new Error("Snapshot failed.");

    await navigator.clipboard.write([
      new ClipboardItem({ "image/png": blob }),
    ]);

    alert("Snapshot copied to clipboard!");
  } catch (err) {
    console.error("Snapshot failed:", err);
    alert("Your browser doesn't support image clipboard copy.");
  } finally {
    // Reset to original width
    tableRef.current.style.width = originalWidth;
  }
};


    const handleRowClick = (e) => {
      if (window.getSelection().toString() === "") {
        handleTaskView(e.id, e?.row?.project_id);
      }
    };

    const handleDateError = (newValue) => {
      console.log(newValue);
    };

    return firstLoading ? (
      <LoadingSpinner />
    ) : (
      <div className="h-full flex flex-col overflow-y-auto">
        <div className="flex flex-row justify-between items-center px-1 mb-2">
          <span></span>
         <div className="flex flex-col md:flex-row flex-wrap justify-end items-start md:items-center gap-4">

  {/* Copy Snapshot Button */}
  <Button
    variant="outlined"
    startIcon={<CameraAltIcon />}
    onClick={handleSnapshotCopy}
    sx={{ minHeight: 40 }}
  >
    Copy Snapshot
  </Button>

  {/* Due Date Picker */}
  <div className="flex items-center gap-2">
    <span className="text-sm font-medium whitespace-nowrap">Due Date:</span>
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DesktopDatePicker
        toolbarPlaceholder="Please enter date"
        className="h-[40px] date-picker rounded-md"
        id="date-picker"
        value={dateFilter ? new Date(dateFilter) : null}
        onError={handleDateError}
        onChange={(selectedDate) => {
          if (!selectedDate) {
            const currentParams = Object.fromEntries(searchParams.entries());
            const updatedParams = { ...currentParams, pageno: 1 };
            delete updatedParams.due_date;

            isMounted.current = false;
            setSearchParams(new URLSearchParams(updatedParams));
            setDateFilter(null);
            setPage(1);
          } else {
            const formattedDate = dayjs(selectedDate).format("YYYY-MM-DD");
            const currentParams = Object.fromEntries(searchParams.entries());
            const updatedParams = {
              ...currentParams,
              pageno: 1,
              due_date: formattedDate,
            };

            isMounted.current = false;
            setSearchParams(new URLSearchParams(updatedParams));
            setDateFilter(formattedDate);
            setPage(1);
          }
        }}
        inputFormat="YYYY-MM-DD"
        format="yyyy-MM-dd"
        slotProps={{
          actionBar: { actions: ["clear"] },
        }}
      />
    </LocalizationProvider>
  </div>

  {/* Project Filter */}
  <div className="min-w-48 w-48">
    <Select
      className="basic-single"
      classNamePrefix="select"
      placeholder="Project"
      name="Project"
      options={projectFilterOptions}
      value={projectFilterOptions.find(
        (option) => option.value === projectFilter
      )}
      onChange={(selectedOption) => {
        const currentParams = Object.fromEntries(searchParams.entries());
        const updatedParams = {
          ...currentParams,
          pageno: 1,
          project: selectedOption.value,
        };
        isMounted.current = false;
        setSearchParams(new URLSearchParams(updatedParams));
        setProjectFilter(selectedOption.value);
        setPage(1);
      }}
    />
  </div>

  {/* Priority Filter */}
  <div className="min-w-36 w-36">
    <Select
      className="basic-single"
      classNamePrefix="select"
      placeholder="Priority"
      name="Priority"
      options={priorityFilterOption}
      value={priorityFilterOption.find(
        (option) => option.value === priorityFilter
      )}
      onChange={(selectedOption) => {
        const currentParams = Object.fromEntries(searchParams.entries());
        const updatedParams = {
          ...currentParams,
          pageno: 1,
          priority: selectedOption.value,
        };
        isMounted.current = false;
        setSearchParams(new URLSearchParams(updatedParams));
        setPriorityFilter(selectedOption.value);
        setPage(1);
      }}
    />
  </div>
</div>

        </div>
        {taskList?.length === 0 ? (
          <div className="no__transcation">
            <img src={noDataFound} alt={noDataFound} loading="lazy" />
          </div>
        ) : (
          <div className="grow overflow-y-auto">
            <div className="h-full flex flex-col justify-between overflow-x-auto overflow-y-auto">
              <div>
                <CustomDataGridTable
                  columns={columns}
                  rows={rows}
                  tableRef={tableRef}
                  hideFooter={true}
                  onRowClick={(e) => handleRowClick(e)}
                  getRowClassName={(params) => {
                    const today = dayjs();
                    const dueDate = dayjs(params?.row?.due_date);

                    if (dueDate.isSame(today, "day")) {
                      return "today";
                    } else if (dueDate.isBefore(today)) {
                      return "Previous";
                    } else {
                      return "";
                    }
                  }}
                  sx={{
                    "& .today": {
                      color: "#ff7b00", //Orange
                    },
                    "& .Previous": {
                      color: "#fc0700", //Red
                    },
                  }}
                />
              </div>
            </div>
          </div>
        )}
        <div style={{ display: "flex" }}>
          <ClickAwayListener onClickAway={handleDrawerClose}>
            <Drawer
              sx={{
                width: drawerWidth,
                flexShrink: 0,
                "& .MuiDrawer-paper": { width: drawerWidth },
              }}
              variant="persistent"
              anchor="right"
              open={open}
            >
              <DrawerTaskDetail
                onClose={handleDrawerClose}
                selectedTaskId={selectedTaskId}
              />
            </Drawer>
          </ClickAwayListener>
        </div>
      </div>
    );
  }
);

export default AllTaskList;

//  : (
//   <div className="grow overflow-y-auto">
//     <div
//       className="h-full flex flex-col justify-between overflow-x-auto overflow-y-auto"
//       ref={taskListRef}
//     >
//       <table className="table max-w-full">
//         <thead className="">
//           <tr className="align-middle">
//             <th
//               scope="col"
//               className="!border-b-[#EFEFEF] font-medium "
//             >
//               Name
//             </th>
//             <th scope="col" className="!border-b-[#EFEFEF] font-medium">
//               Project
//             </th>
//             <th scope="col" className="!border-b-[#EFEFEF] font-medium">
//               Due Date
//             </th>
//             <th scope="col" className="!border-b-[#EFEFEF] font-medium">
//               Status
//             </th>
//             <th scope="col" className="!border-b-[#EFEFEF] font-medium">
//               Priority
//             </th>
//             {/* <th scope="col" className="!border-b-[#EFEFEF] font-medium">
//                                 Total Time
//                             </th> */}
//             {/* <th scope="col" className="!border-b-[#EFEFEF] font-medium">

//                             </th> */}
//           </tr>
//         </thead>
//         <tbody>
//           {taskList?.map((item, index) => {
//             const timeDuration = dayjs.duration(
//               item.duration,
//               "seconds"
//             );
//             const hours = String(timeDuration.hours()).padStart(2, "0");
//             const minutes = String(timeDuration.minutes()).padStart(
//               2,
//               "0"
//             );
//             const formattedTime = `${hours}:${minutes}`;
//             return (
//               <tr
//                 className={`align-middle border-b-0 hover:bg-[#f7f7f7] hover:rounded-lg overflow-hidden cursor-pointer ${
//                   item?.is_completed ? "opacity-50" : "opacity-100"
//                 }`}
//                 onClick={(e) => {
//                   if (window.getSelection().toString() === "") {
//                     handleTaskView(item.id, item?.project?.id);
//                   }
//                 }}
//                 key={index}
//               >
//                 <td className="border-b-0 !border-b-[#EFEFEF] p-2 !max-w-[30vw] overflow-hidden">
//                   <div className="flex items-center w-full gap-1">
//                     <div
//                       className={`rounded-full border flex items-center
//                                                                     ${
//                                                                       !item?.is_completed
//                                                                         ? "bg-white text-black"
//                                                                         : "bg-green-600 text-white"
//                                                                     } cursor-pointer`}
//                       onClick={async (e) => {
//                         e.stopPropagation();
//                         await handleTaskComplete(
//                           item.id,
//                           item?.is_completed
//                         );
//                         await getTaskList();
//                       }}
//                     >
//                       <IoIosCheckmark />
//                     </div>
//                     <div className="truncate">
//                       {item?.title || "--"}
//                     </div>
//                   </div>
//                 </td>
//                 <td className="border-b-0 !border-b-[#EFEFEF] truncate">
//                   {item?.project?.name || "--"}
//                 </td>
//                 <td className="border-b-0 !border-b-[#EFEFEF] w-[15%]">
//                   {item?.due_date
//                     ? dayjs(item.due_date).format("DD-MM-YYYY")
//                     : "--"}
//                 </td>
//                 <td className="table_tr_style align-middle">
//                   <div
//                     className={`${
//                       item?.task_status?.title === "In Progress"
//                         ? "text-[#db763b] bg-[#eeb08c3d]"
//                         : item?.task_status?.title === "Completed"
//                         ? "text-[#83BF6E] bg-[#83bf6e24]"
//                         : item?.task_status?.title === "To be verified"
//                         ? "text-[#8E59FF] bg-[#8e59ff1a]"
//                         : item?.task_status?.title === "To do"
//                         ? "text-[#6F767E] bg-[#6f767e2b]"
//                         : item?.task_status?.title === "Confirm-Sale"
//                         ? "text-[#6F767E] bg-[#6F767E24]"
//                         : item?.task_status?.title === "Open"
//                         ? "text-[#83BF6E] bg-[#83bf6e24]"
//                         : item?.task_status?.title === "Closed"
//                         ? "text-[#EE404C] bg-[#ff00001a]"
//                         : item?.task_status?.title === "In Meeting"
//                         ? "text-[#8E59FF] bg-[#8e59ff1a]"
//                         : "text-[#6F767E] bg-[#6f767e2b]"
//                     }
//                                         py-[6px] px-[12px] rounded-[6px] text-base whitespace-nowrap text-capitalize w-[120px] d-flex justify-center`}
//                   >
//                     {item?.task_status?.title}
//                   </div>
//                 </td>
//                 <td className="table_tr_style align-middle w-[10%]">
//                   {item?.priority ? (
//                     <span
//                       className={`flex flex-row gap-1 justify-start items-center`}
//                     >
//                       {customIcons[item?.priority]} {item?.priority}
//                     </span>
//                   ) : (
//                     "--"
//                   )}
//                 </td>
//                 {/* <td className="table_tr_style align-middle">
//                                             <div className="flex flex-row justify-start items-center gap-1 max-w-full">
//                                                 <img src={clock_inActive} alt="Clock Icon" className="w-4 h-4 min-w-[16px]" />
//                                                 <span className="w-[40px]">{formattedTime}</span>
//                                             </div>
//                                         </td> */}

//                 {/* <td className="border-b-0 !border-b-[#EFEFEF] text-right w-[15%]">
//                                             <div className='flex flex-row items-center gap-2 justify-end'>
//                                                 {
//                                                     runningTask && runningTask?.task.id === item.id ?
//                                                         <button className='flex flex-row items-center gap-1 border justify-start text-black rounded-md p-2 hover:!border-black w-[110px]'
//                                                             onClick={(e) => {
//                                                                 e.stopPropagation();
//                                                                 handlePause()
//                                                             }}
//                                                         >
//                                                             <FaStop className='h-[12px]' /> Stop
//                                                         </button>
//                                                         :
//                                                         <button className='flex flex-row items-center gap-1 border justify-start text-black rounded-md p-2  hover:!border-[#c9c4c4] w-[110px]'
//                                                             onClick={(e) => {
//                                                                 e.stopPropagation();
//                                                                 onStart(item, e)
//                                                             }}
//                                                         >
//                                                             <img className='h-[11px] w-[11px]' src={start_button} alt="start_button" /> {item?.duration != 0 ? "Continue" : "Start"}
//                                                         </button>
//                                                 }
//                                                 <Tooltip title="Add manual hours">
//                                                     <img src={RequestIconActive} alt='!!' className='h-5 w-5 cursor-pointer'
//                                                         onClick={(e) => {
//                                                             e.stopPropagation();
//                                                             handleRequestModal(item);
//                                                         }}
//                                                     />
//                                                 </Tooltip>
//                                             </div>
//                                         </td> */}
//               </tr>
//             );
//           })}
//         </tbody>
//       </table>
//       {loading && (
//         <div className="w-full my-2 flex items-center justify-center">
//           Loading...
//         </div>
//       )}
//     </div>
//   </div>
// )}
